
import PropTypes from 'prop-types'
import React from 'react'
import ShowHide from './ShowHide'
import Offscreen from './Offscreen'
import './Dialog.css'

const Dialog = props => (
  <section role='dialog' aria-label={props.label || props.title} className='ui-Dialog' onClick={e => e.stopPropagation()}>
    <div className='ui-Dialog-wrapper'>
      <ShowHide show={props.onClose}>
        <button type='button' className='ui-Dialog-close' onClick={props.onClose}>
          <Offscreen>
            Close
          </Offscreen>
        </button>
      </ShowHide>

      <ShowHide show={props.title}>
        <h3 className='ui-Dialog-title'>{props.title}</h3>
      </ShowHide>

      <div className='ui-Dialog-body'>
        <div className='ui-Dialog-content'>{props.children}</div>
        {props.actions ? <div className='ui-Dialog-options'>{props.actions}</div> : null}
      </div>
    </div>
  </section>
)

Dialog.displayName = 'Dialog'

Dialog.propTypes = {
  actions: PropTypes.node,
  children: PropTypes.node,
  title: PropTypes.string,
  label: PropTypes.string,
  onClose: PropTypes.func
}

export default Dialog



// WEBPACK FOOTER //
// ./ui/Dialog.js